export default __webpack_public_path__ + "static/media/arrowForward.8ba16881.svg";